import messages from '../validators/messages';
var Validators = {
  messages: messages,
  urlProtocols: ['http', 'https']
};
export default Validators;